import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../../actions'
import axios from 'axios'
import { Container, Button, TableRow, TableHeaderCell, TableHeader, TableCell, TableBody, Table, Grid, GridColumn, Input, Confirm, Icon, Popup, Form, FormField, Message } from 'semantic-ui-react'

const ResellersTable = ({ onChangeItem }) => {
    const [topUpAmount, setTopUpAmount] = useState('')
    const [deductAmount, setDeductAmount] = useState('')
    const [showSuccessMessage, setShowSuccessMessage] = useState(false)
    const [successMessageHeaderStr, setSuccessMessageHeaderStr] = useState('')
    const [topUpButtonLoading, setTopUpButtonLoading] = useState(false)
    const [deductButtonLoading, setDeductButtonLoading] = useState(false)
    const [isSearching, setIsSearching] = useState(false)
    const [searchString, setSearchString] = useState('')
    const [showDeleteConfirmationPopup, setShowDeleteConfirmationPopup] = useState(false)
    const [idToDelete, setIdToDelete] = useState(null)
    const [deleteConfirmContentString, setDeleteConfirmContentString] = useState('')

    const resellers = useSelector(state => state.resellers)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(actions.fetchResellers())
    }, [dispatch])

    const handleChangeSearchField = e => {
        setShowSuccessMessage(false)
        const { value } = e.target
        if (value === '') {
            setIsSearching(false)
        } else {
            setIsSearching(true)
            setSearchString(value)
        }
    }
    const handleChangeTopUpAmount = e => {
        setShowSuccessMessage(false)
        const { value } = e.target
        setTopUpAmount(value)
    }
    const handleChangeDeductAmount = e => {
        setShowSuccessMessage(false)
        const { value } = e.target
        setDeductAmount(value)
    }
    const handleResellerClicked = reseller => {
        setShowSuccessMessage(false)
        onChangeItem('edit-reseller', reseller)
    }
    const handleTopUpBalanceClicked = async reseller => {
        setTopUpButtonLoading(true)
        const dict = { amount: Number(topUpAmount) }
        await axios.post('/api/balance_topup/reseller/' + reseller._id, dict)
            .then(() => {
                dispatch(actions.fetchResellers())
                setTopUpButtonLoading(false)
                setShowSuccessMessage(true)
                setSuccessMessageHeaderStr('$' + topUpAmount + ' top up success for ' + reseller.name)
                setTopUpAmount(0)
            })
            .catch(err => {
                console.log(`top up reseller balance failed with error: ${err}`)
                alert(`Failure top up reseller balance, please try again. Error: ${err}`)
                setTopUpButtonLoading(false)
            })
    }
    const handleDeductBalanceClicked = async reseller => {
        setDeductButtonLoading(true)
        const dict = { amount: Number(deductAmount) }
        await axios.post('/api/balance_deduct/reseller/' + reseller._id, dict)
            .then(() => {
                dispatch(actions.fetchResellers())
                setDeductButtonLoading(false)
                setShowSuccessMessage(true)
                setSuccessMessageHeaderStr('$' + deductAmount + ' deduction success for ' + reseller.name)
                setDeductAmount(0)
            })
            .catch(err => {
                console.log(`top up reseller balance failed with error: ${err}`)
                alert(`Failure top up reseller balance, please try again. Error: ${err}`)
                setDeductButtonLoading(false)
            })
    }
    const handleDeleteClicked = (e, reseller) => {
        e.stopPropagation()
        if (showDeleteConfirmationPopup) return
        const contentString = "Delete reseller '" + reseller.name + "'?"
        setIdToDelete(reseller._id)
        setDeleteConfirmContentString(contentString)
        setShowDeleteConfirmationPopup(true)
    }
    const handleDeleteCancel = () => {
        setShowDeleteConfirmationPopup(false)
    }
    const handleDeleteConfirm = async () => {
        await axios.delete('/api/reseller/' + idToDelete)
            .then(() => {
                setShowDeleteConfirmationPopup(false)
                dispatch(actions.fetchResellers())
            })
            .catch(err => {
                console.log(`delete reseller failed with error: ${err}`)
                alert(`Failure deleting reseller, please try again. Error: ${err}`)
            })
    }

    const renderTableRows = () => {
        const data = isSearching ? resellers.filter(reseller =>
                  ['name', 'email', 'phone'].some(field =>
                      reseller[field]?.toLowerCase?.()?.includes(searchString.toLowerCase())
                  )
              ) : resellers
        const rows = []
        for (const [i, reseller] of data.entries()) {
            rows.push(
                <TableRow key={i} style={{ cursor: 'pointer' }} onClick={() => handleResellerClicked(reseller)}>
                    <TableCell style={{ color: 'white' }}>{reseller.name}</TableCell>
                    <TableCell style={{ color: 'white' }}>{reseller.email}</TableCell>
                    <TableCell style={{ color: 'white' }}>
                        {(reseller.balance || 0).toFixed(2)}
                        <Popup inverted style={{ textAlign: 'center' }} wide on="click" position="right center"
                            trigger={
                                <Button inverted style={{ marginLeft: 12, marginRight: 5 }} size="mini" circular basic icon onClick={e => e.stopPropagation()} ><Icon inverted name="plus" /></Button>
                            }>
                            <div onClick={e => e.stopPropagation()}>
                                <Form inverted style={{ marginTop: 12, marginLeft: 20, marginRight: 20, marginBottom: 20 }}>
                                    <FormField control={Input} label="Amount to Top Up" value={topUpAmount} placeholder="Amount to Top Up" onChange={handleChangeTopUpAmount} inverted/>
                                </Form>
                                <Button inverted loading={topUpButtonLoading} fluid style={{ marginBottom: 12 }} onClick={() => handleTopUpBalanceClicked(reseller)}><Icon inverted name="add" />Top Up</Button>
                            </div>
                        </Popup>
                        <Popup inverted style={{ textAlign: 'center' }} wide on="click" position="right center" trigger={
                                <Button inverted size="mini" circular basic icon onClick={e => e.stopPropagation()}><Icon inverted name="minus" /></Button>
                            }>
                            <div onClick={e => e.stopPropagation()}>
                                <Form inverted style={{ marginTop: 12, marginLeft: 20, marginRight: 20, marginBottom: 20 }}>
                                    <FormField control={Input} label="Amount to Deduct" value={deductAmount} placeholder="Amount to Deduct" onChange={handleChangeDeductAmount} inverted/>
                                </Form>
                                <Button inverted loading={deductButtonLoading} fluid style={{ marginBottom: 12 }} onClick={() => handleDeductBalanceClicked(reseller)}>
                                    <Icon inverted name="minus" />Deduct
                                </Button>
                            </div>
                        </Popup>
                    </TableCell>
                    <TableCell collapsing>
                        <Button inverted circular basic icon onClick={e => handleDeleteClicked(e, reseller)}>
                            <Icon inverted name="trash alternate" />
                        </Button>
                    </TableCell>
                </TableRow>
            )
        }
        return rows
    }
    const renderTable = () => {
        if (!resellers) return null
        return <Table size={window.innerWidth < 768 ? 'small' : null} unstackable inverted style={window.innerWidth < 768 ? { overflowX: 'auto', display: 'block', whiteSpace: 'nowrap' } : null}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Name</TableHeaderCell>
                        <TableHeaderCell>Email</TableHeaderCell>
                        <TableHeaderCell>Balance</TableHeaderCell>
                        <TableHeaderCell></TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {renderTableRows()}
                </TableBody>
            </Table>
    }

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            <Grid style={{ marginTop: 10, marginBottom: 15 }}>
                <GridColumn floated="left" width={5}>
                    <h1 style={{ color: 'white' }}>Resellers</h1>
                </GridColumn>
                <GridColumn width={6}>
                    <Input inverted fluid action={{ icon: 'search', color: 'teal', inverted: true }} placeholder="Search reseller..." onChange={handleChangeSearchField} style={{ border: '1px #333 solid' }} input={<input style={{ backgroundColor: '#1b1c1d', color: 'white' }} />}/>
                </GridColumn>
                <GridColumn floated="right" width={5}>
                    <Button size={window.innerWidth <= 760 ? 'mini' : null} inverted color='teal' floated="right" onClick={() => onChangeItem('new-reseller')}><Icon inverted color='teal' name="add" />Create New Reseller</Button>
                </GridColumn>
            </Grid>
            {showSuccessMessage ? (
                <Message inverted success header={successMessageHeaderStr}></Message>
            ) : null}
            {renderTable()}
            <Confirm inverted open={showDeleteConfirmationPopup} onCancel={handleDeleteCancel} onConfirm={handleDeleteConfirm} header="Confirmation" content={deleteConfirmContentString} cancelButton="Cancel" confirmButton="Delete"/>
        </Container>
    )
}

export default ResellersTable